// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {
    usersProfiles: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.usersProfiles.main) {
            if(consts.app.$isDevelopment) console.warn('usersProfiles', route);
            return false
        }
        router.push({
            name: consts.routerNames.usersProfiles.main,
            params: {},
            query: {}
        })
    },
    usersProfilesClearQuery: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.usersProfiles.main) {
            if(consts.app.$isDevelopment) console.warn('usersProfilesClearQuery', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
            },
            query: {}
        })
    },
    usersProfilesEdit: (route, router, userProfileId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.usersProfiles.main) {
            if(consts.app.$isDevelopment) console.warn('usersProfilesEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.usersProfiles.edit.main,
            params: {
                userProfileId,
            },
            query: {...query}
        })
    },
    usersProfilesHistory: (route, router, userProfileId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.usersProfiles.main) {
            if(consts.app.$isDevelopment) console.warn('usersProfilesHistory', route);
            return false
        }
        router.push({
            name: consts.routerNames.usersProfiles.history,
            params: {
                userProfileId,
            },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'users-profiles',
        name: consts.routerNames.usersProfiles.main,
        meta: {
            mainRouteName: consts.routerNames.usersProfiles.main,
            bodyGrid: "1X1",
            showHead: true,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/admin/UsersProfilesPage.vue'),
        children: [
            {
                path: ':userProfileId(\\d)?/edit',
                name: consts.routerNames.usersProfiles.edit.main,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            titlePosition: 'center',
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        wrapper: 'EditWizard',
                        class: 'popup-body',
                        userProfileId: route?.params?.userProfileId
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/users-profiles/user-profile-edit/UserProfileEdit.vue'),
                }
            },
        ]
    },
];

export default routes;